import React from 'react';
import PropTypes from 'prop-types';
import { Icons, HTML } from '..';
import { applyClasses, applyProps } from '../shared/js';

import styles from './nav.module.scss';

const NavLogo = (props) => (
  <HTML tag="div" flex className={applyClasses(props, styles)} {...applyProps}>
    <a
      href="https://www.sonnet.ca/"
      onClick={props.onClick}
      className={styles.logo}
    >
      <Icons.Logo />
    </a>
  </HTML>
);

NavLogo.propTypes = {
  /** A style object forwarded to the logo's wrapping element */
  style: PropTypes.any,
  /** A class name forwarded to the logo's wrapping element */
  className: PropTypes.string,
  /** A callback function called when clicking the Logo button */
  onClick: PropTypes.func,
};

NavLogo.defaultProps = {
  style: undefined,
  className: undefined,
  onClick: () => {},
};

export default NavLogo;
